import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'titleAndDescription',
    label: 'Title and Description',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
